import React from 'react';
import { FolderKanban, Shield, Users, TrendingUp } from 'lucide-react';
import { KpiCard } from '../components/dashboard/KpiCard';
import { RecentProjects } from '../components/dashboard/RecentProjects';
import { RevenueChart } from '../components/dashboard/RevenueChart';
import { Card } from '../components/ui/Card';
import { useAppStore } from '../contexts/AppStore';

export const DashboardPage: React.FC = () => {
  const { projects, ipAssets, stakeholders, contracts } = useAppStore();
  
  // Calcular KPIs
  const activeProjects = projects.filter(
    p => p.status !== 'Licenciado'
  ).length;
  
  const grantedPatents = ipAssets.filter(
    ip => ip.status === 'Concedida'
  ).length;
  
  const companiesContacted = stakeholders.filter(
    s => s.type === 'Empresa'
  ).length;
  
  // Calcular ingresos totales de contratos vigentes
  const totalRevenue = contracts
    .filter(c => c.status === 'Vigente')
    .reduce((sum, c) => sum + c.value, 0);
  
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-600 mt-1">
          Vista general de la actividad de la OTRI
        </p>
      </div>
      
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <KpiCard
          title="Proyectos Activos"
          value={activeProjects}
          icon={FolderKanban}
          color="blue"
          trend={{ value: 12, isPositive: true }}
        />
        
        <KpiCard
          title="Patentes Concedidas"
          value={grantedPatents}
          icon={Shield}
          color="green"
          trend={{ value: 8, isPositive: true }}
        />
        
        <KpiCard
          title="Empresas Contactadas"
          value={companiesContacted}
          icon={Users}
          color="purple"
          trend={{ value: 5, isPositive: false }}
        />
        
        <KpiCard
          title="Ingresos (Contratos Vigentes)"
          value={`$${(totalRevenue / 1000000).toFixed(1)}M`}
          icon={TrendingUp}
          color="orange"
          trend={{ value: 15, isPositive: true }}
        />
      </div>
      
      {/* Proyectos Recientes */}
      <RecentProjects projects={projects} />
      
      {/* Gráfico de Ingresos */}
      <Card>
        <RevenueChart />
      </Card>
    </div>
  );
};
